import { render } from "./Order_B.vue?vue&type=template&id=4587d020&scoped=true"
import script from "./Order_B.vue?vue&type=script&lang=js"
export * from "./Order_B.vue?vue&type=script&lang=js"

import "@/assets/css/user/common.css?vue&type=style&index=0&id=4587d020&scoped=true&lang=css"
import "@/assets/css/user/pages/main.css?vue&type=style&index=1&id=4587d020&scoped=true&lang=css"
import "@/assets/css/user/pages/main-b.css?vue&type=style&index=2&id=4587d020&scoped=true&lang=css"
import "@/assets/css/user/pages/table.css?vue&type=style&index=3&id=4587d020&scoped=true&lang=css"
import "@/assets/css/user/dark/common-dark.css?vue&type=style&index=4&id=4587d020&scoped=true&lang=css"
import "@/assets/css/user/dark/main-dark.css?vue&type=style&index=5&id=4587d020&scoped=true&lang=css"
import "@/assets/css/user/dark/main-b-dark.css?vue&type=style&index=6&id=4587d020&scoped=true&lang=css"
import "@/assets/css/user/pages/admin.css?vue&type=style&index=7&id=4587d020&scoped=true&lang=css"
import "./Order_B.vue?vue&type=style&index=8&id=4587d020&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shcho\\Desktop\\home\\git\\test\\cloudpos.kiosk\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4587d020"]])

export default __exports__